/**
 * An alert's priority dot and its due pill (v1 completion I §10): the words are
 * the server's (`due_label`, Ben's d73 copy); the colour says late, due today,
 * acknowledged or cleared.
 */
import type { NeedsAttentionItem } from "@shared-core/data/needs-attention-types";
import { Badge } from "../../primitives/badge";
import { cn } from "../../primitives/utils";

const DOT: Record<string, string> = {
  urgent: "bg-destructive",
  high: "bg-destructive",
  normal: "bg-amber-600 dark:bg-amber-400",
  low: "bg-muted-foreground",
};

export function PriorityDot({ priority }: { priority: string }) {
  return (
    <span
      aria-label={`Priority: ${priority}`}
      className={cn(
        "mr-2 inline-block size-2 shrink-0 rounded-full",
        DOT[priority] ?? DOT.low,
      )}
    />
  );
}

export function DuePill({
  alert,
}: {
  alert: Pick<NeedsAttentionItem, "due_label" | "is_overdue" | "state">;
}) {
  if (alert.state === "cleared")
    return <Badge variant="neutral">Cleared</Badge>;
  if (alert.is_overdue) return <Badge variant="error">{alert.due_label}</Badge>;
  if (alert.due_label === "Due today")
    return <Badge variant="warning">{alert.due_label}</Badge>;
  return <Badge variant="outline">{alert.due_label}</Badge>;
}
